/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import * as React from "react";
import type { SVGIconProps } from "../../svgIconProps";
import { IconSize } from "../../iconTypes";
import { SVGIconContainer } from "../../svgIconContainer";

export const Basket: React.FC<SVGIconProps> = React.forwardRef<any, SVGIconProps>(({size = IconSize.STANDARD, ...props}, ref) => {
    const isLarge = size! >= IconSize.LARGE;
    const pixelGridSize = isLarge ? IconSize.LARGE : IconSize.STANDARD;
    const translation = `${-1 * pixelGridSize / 0.014705882352941176 / 2}`;
    const style = { transformOrigin: "center" };
    return (
        <SVGIconContainer iconName="basket" ref={ref} size={size} {...props}>
            <path
                d={isLarge ? "M551.5570666666667 868.8904H627.1141333333334V340H551.5570666666667V868.8904zM853.7808000000001 868.8904H778.2237333333334V340H853.7808000000001V868.8904zM551.5570666666667 1095.5557066666665V1196.2963466666668C551.5570666666667 1224.1151466666668 574.1104 1246.6666666666667 601.9269333333333 1246.6666666666667H803.4109333333334C831.2274666666666 1246.6666666666667 853.7808000000001 1224.1151466666668 853.7808000000001 1196.2963466666668V1095.5557066666665H1156V1020H1080.4429333333335V113.3333333333333H324.88904V1020H249.3333333333334V1095.5557066666665H551.5570666666667zM627.1141333333334 1095.5557066666665V1171.11096H778.2237333333334V1095.5557066666665H627.1141333333334zM400.4442933333334 1020V188.8903999999998H1004.8904V1020H400.4442933333334z" : "M441.2456533333334 695.11232H501.6913066666666V272H441.2456533333334V695.11232zM683.02464 695.11232H622.5789866666667V272H683.02464V695.11232zM441.2456533333334 876.4445653333333V957.0370773333334C441.2456533333334 979.2921173333332 459.2883199999999 997.3333333333334 481.5415466666666 997.3333333333334H642.7287466666667C664.9819733333333 997.3333333333334 683.02464 979.2921173333332 683.02464 957.0370773333334V876.4445653333333H924.8V816H864.3543466666667V90.6666666666667H259.911232V816H199.4666666666667V876.4445653333333H441.2456533333334zM501.6913066666666 876.4445653333333V936.888768H622.5789866666667V876.4445653333333H501.6913066666666zM320.3554346666667 816V151.11232H803.9123199999999V816H320.3554346666667z"}
                fillRule="evenodd"
                transform={`scale(0.014705882352941176, -0.014705882352941176) translate(${translation}, ${translation})`}
                style={style}
            />
        </SVGIconContainer>
   );
});
Basket.displayName = `Blueprint5.Icon.Basket`;
export default Basket;
